















import Vue from "vue";
import { mutations } from "../../services/store";

export default Vue.extend({
  props: {
    id: {
      type: String
    },
    getScrollableElement: {
      type: Function
    }
  },
  methods: {
    closeDialog() {
      this.$dialog.close(this.id);
    },
    handleOnShow() {
      mutations.setIsShowBottomDialog(true);
      this.$emit("onShow");
    },
    handleOnHide() {
      mutations.setIsShowBottomDialog(false);
      this.$emit("onHide");
    }
  }
});
